import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AppLayoutComponent } from "../../../shared/components/app-layout/app-layout.component";
import { ButtonComponent } from "../../../shared/components/button/button.component";
import { PageHeaderComponent } from "../../../shared/components/page-header/page-header.component";
import { SellerAssignedEventsListComponent } from "./seller-assigned-events-list.component";

@Component({
  selector: "app-seller-events-page",
  imports: [
    CommonModule,
    AppLayoutComponent,
    ButtonComponent,
    PageHeaderComponent,
    SellerAssignedEventsListComponent,
  ],
  templateUrl: "./seller-events-page.component.html",
  styleUrl: "./seller-events-page.component.scss",
})
export class SellerEventsPageComponent {
  constructor(private readonly router: Router) {}

  goToSellerOrders(): void {
    this.router.navigate(["/seller-orders"]);
  }
}
